import * as THREE from 'three';
import CameraControls from 'camera-controls';
import { PARAMS } from '../sim/params';

/**
 * Touch god-camera: one-finger pan (ground-parallel), pinch zoom,
 * two-finger rotate. Pitch clamped to keep the isometric-ish 1994 framing.
 * camera-controls instead of OrbitControls per the touch-jank research.
 */
let installed = false;

export function createCameraRig(
  camera: THREE.PerspectiveCamera,
  element: HTMLElement,
): CameraControls {
  if (!installed) {
    CameraControls.install({ THREE });
    installed = true;
  }

  const controls = new CameraControls(camera, element);
  controls.minDistance = 8;
  // full pinch-out frames the entire island; a steeper top-down is allowed
  // when zoomed way out so the whole coast fits in the narrow FOV
  controls.maxDistance = 150;
  controls.minPolarAngle = THREE.MathUtils.degToRad(20); // near top-down when far out
  controls.maxPolarAngle = THREE.MathUtils.degToRad(60); // pitch 30° above horizon
  controls.smoothTime = 0.15;
  controls.draggingSmoothTime = 0.06;

  // SCREEN_PAN pans along the ground plane (god-game pan), not the camera plane
  controls.mouseButtons.left = CameraControls.ACTION.SCREEN_PAN;
  controls.mouseButtons.right = CameraControls.ACTION.ROTATE;
  controls.mouseButtons.wheel = CameraControls.ACTION.DOLLY;
  controls.touches.one = CameraControls.ACTION.TOUCH_SCREEN_PAN;
  controls.touches.two = CameraControls.ACTION.TOUCH_DOLLY_ROTATE;

  const b = PARAMS.WORLD_SIZE * 0.45;
  controls.setBoundary(
    new THREE.Box3(new THREE.Vector3(-b, 0, -b), new THREE.Vector3(b, 4, b)),
  );

  controls.setLookAt(8, 11, 15, 0, 0.6, 0, false);
  return controls;
}
